
import React from 'react';
import BusRatesTable from './BusRatesTable';
import { Helmet } from 'react-helmet';
import GoogleAnalytics from '../components/GoogleAnalytics';

const Packages = () => {
  return (
   <div>
   <GoogleAnalytics/>
   <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">Packages </h1>
          </div>
        </div>
      </section>



<BusRatesTable/>
   </div>
  );
};

export default Packages;
